import React from 'react';
import { FINISH_STEP, GO_BACK_TO_STEP, } from '../../storage/TutorialReducer';
import { withRouter } from 'react-router-dom';

class TutorialStep5 extends React.Component {
  componentDidMount () {
    if (this.props.location.pathname !== '/coupons') {
      this.props.history.push('/coupons');
    }
  }

  goNext () {
    Storage.dispatch({type: FINISH_STEP, payload: 5});
  }

  goBack () {
    Storage.dispatch({type: GO_BACK_TO_STEP, payload: 4});
  }

  render () {
    return (
      <div className="c-tutorial-element">
        <h2 className="c-tutorial-element__subtitle">
          Redeem coupon page
        </h2>
        <p>
          This one is pretty simple, if you get valid ASC coupon, you enter it here and your award awaits.
        </p>

        <div className="c-tutorial-element__button-container">
          <button onClick={this.goBack}>Back</button>
          <button onClick={this.goNext}>Next</button>
        </div>
      </div>
    );
  }
}

export default withRouter(TutorialStep5);



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep5.js